<script lang="ts" setup>
  import CBtn from '@shared/components/ui/c-btn.vue'

  const props = defineProps<{
    snapshot: string
  }>()
  const emit = defineEmits(['on-save', 'on-delete'])
  const onDelete = () => {
    emit('on-delete', props.snapshot)
  }
  const onSave = () => {
    emit('on-save', props.snapshot)
  }
</script>

<template>
  <div class="tw-bg-grey-300 tw-w-full tw-h-full">
    <div class="tw-py-32 tw-px-48 tw-h-[calc(100%-72px)] tw-flex tw-items-center tw-justify-center">
      <img :src="snapshot" class="tw-w-full" />
    </div>
    <div
      class="tw-flex tw-justify-around tw-z-10 md:tw-hidden tw-fixed tw-bottom-0 tw-py-12 tw-bg-white tw-shadow-100 tw-w-full"
    >
      <c-btn outlined @click="onDelete"> Delete </c-btn>
      <c-btn @click="onSave"> Save snapshot </c-btn>
    </div>
  </div>
</template>
